import CLang from './c-lang';

export default CLang;
